<script setup lang="ts">
import { ref, onMounted } from 'vue';

// Get email from localStorage
const userEmail = ref('');

onMounted(() => {
    userEmail.value = localStorage.getItem('user_email') || 'No email found';
});
</script>

<template>
    <div class="w-full flex flex-col items-center pb-4">
        <div class="w-full max-w-md">
            <!-- Email Section -->
            <div class="bg-white rounded-lg shadow mb-4">
                <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100">
                    <div class="font-medium text-gray-700">
                        {{ $t("profile.email") }}
                    </div>
                    <div class="text-gray-500 break-all text-right">
                        {{ userEmail }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
